import React from "react";
import MetricCard from "../MetricCard";

interface CloseRateCardProps {
  closedDealsCount: number;
  nonDisqualifiedLeads: number;
  timeFrame?: string;
  noData?: boolean;
}

const CloseRateCard: React.FC<CloseRateCardProps> = ({
  closedDealsCount,
  nonDisqualifiedLeads,
  timeFrame = "Past 30 days",
  noData = false,
}) => {
  // Calculate close rate as a percentage of closed deals / non-disqualified leads
  const closeRate =
    nonDisqualifiedLeads > 0
      ? Math.round((closedDealsCount / nonDisqualifiedLeads) * 100)
      : 0;

  return (
    <MetricCard
      title="Win Rate"
      value={`${closeRate}%`}
      tooltip={`Percentage of leads that resulted in revenue (${timeFrame})`}
      min={0}
      max={100}
      current={closeRate}
      hideMinLabel={true}
      rightLabel="100%"
      noData={noData}
      hideProgress={false}
      hideRightLabel={false}
    />
  );
};

export default CloseRateCard;
